import { render, staticRenderFns } from "./DynamicDepositStep.vue?vue&type=template&id=f04dd40e&scoped=true"
import script from "./DynamicDepositStep.vue?vue&type=script&lang=js"
export * from "./DynamicDepositStep.vue?vue&type=script&lang=js"
import style0 from "./DynamicDepositStep.vue?vue&type=style&index=0&id=f04dd40e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04dd40e",
  null
  
)

export default component.exports